import { Box, Typography, Container } from "@mui/material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const Home = () => {

  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', pt: { xs: 2, md: 4 }, pb: { xs: 4, md: 8 } }} className="bg-gray-50 min-h-screen pt-4 pb-8">
      <Container maxWidth="md" sx={{ py: { xs: 6, md: 10 } }}>
        <Box textAlign="center" mb={6}>
          <Typography variant="h2" fontWeight={800} gutterBottom color="primary" sx={{ mb: 2 }}>
            Fonctionnalités essentielles
          </Typography>
          <Typography variant="h5" color="text.secondary" sx={{ maxWidth: 600, mx: 'auto', mb: 4 }}>
            Planifiez, organisez et partagez votre saison facilement.
          </Typography>
        </Box>
        <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} justifyContent="center" alignItems="stretch" gap={4}>
          <Box flex={1} minWidth={240} bgcolor="#f8fafc" borderRadius={3} p={4} boxShadow={1}>
            <Box mb={2} color="primary.main" fontSize={36} display="flex" justifyContent="center">
              <AddCircleOutlineIcon fontSize="inherit" />
            </Box>
            <Typography variant="h6" fontWeight={700} gutterBottom textAlign="center">Créer une planification</Typography>
            <Typography color="text.secondary" fontSize={16} textAlign="center">
              Concevez rapidement vos cycles, périodes, séances et thèmes pour toute la saison.
            </Typography>
          </Box>
          <Box flex={1} minWidth={240} bgcolor="#f8fafc" borderRadius={3} p={4} boxShadow={1}>
            <Box mb={2} color="primary.main" fontSize={36} display="flex" justifyContent="center">
              <SportsSoccerIcon fontSize="inherit" />
            </Box>
            <Typography variant="h6" fontWeight={700} gutterBottom textAlign="center">Organisation visuelle</Typography>
            <Typography color="text.secondary" fontSize={16} textAlign="center">
              Visualisez votre planification sous forme de tableaux, par cycles, périodes et thèmes.
            </Typography>
          </Box>
          <Box flex={1} minWidth={240} bgcolor="#f8fafc" borderRadius={3} p={4} boxShadow={1}>
            <Box mb={2} color="primary.main" fontSize={36} display="flex" justifyContent="center">
              <ContentCopyIcon fontSize="inherit" />
            </Box>
            <Typography variant="h6" fontWeight={700} gutterBottom textAlign="center">Partage & collaboration</Typography>
            <Typography color="text.secondary" fontSize={16} textAlign="center">
              Partagez vos programmations avec votre adjoint ou staff.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Home;
